import React, { useEffect, useState } from 'react';

import styles from './ColorPicker.module.scss';

const defaultColorPalete = [
  '#61bd4f',
  '#f2d600',
  '#ff9f1a',
  '#eb5a46',
  '#c377e0',
  '#0079bf',
  '#00c2e0',
  '#51e898',
  '#ff78cb',
  '#344563',
];

interface ColorPickerProps {
  colorSelected?: string;
  setColorSelected: (color?: string) => void;
}

export default function ColorPicker({
  colorSelected,
  setColorSelected,
}: ColorPickerProps) {
  const [showAvailableColors, setShowAvailableColors] = useState(false);
  const [availableColors, setAvailableColors] = useState<string[]>([]);
  const withoutColor = '#b3bac5';

  useEffect(() => {
    setAvailableColors(defaultColorPalete);
  }, []);

  return (
    <div className={styles.colorPicker}>
      <div className={styles.selectedColor}>
        <span
          role='button'
          aria-hidden='true'
          className={styles.labelColor}
          style={{ backgroundColor: colorSelected || withoutColor }}
          onClick={(e) => setShowAvailableColors(!showAvailableColors)}
        />
      </div>
      {showAvailableColors && (
        <div className={styles.availableColors}>
          {availableColors.map((color) => {
            return (
              <span
                key={color}
                role='button'
                aria-hidden='true'
                style={{ backgroundColor: color }}
                className={`${styles.labelColor} ${
                  colorSelected === color ? styles.SelectedColor : ''
                }`}
                onClick={() => setColorSelected(color)}
              />
            );
          })}
          <div className={styles.withoutColor}>
            <span
              role='button'
              aria-hidden='true'
              style={{ backgroundColor: withoutColor }}
              className={styles.labelColor}
              onClick={() => setColorSelected()}
            />
            <span className='fst-italic'>Sem cor</span>
          </div>
        </div>
      )}
    </div>
  );
}
